<template>
  <div>
<!--    <div style="margin: 10px 0 20px 0">-->
<!--      <img src="../../../../assets/images/logo-small.png" style="width: 140px"/>-->
<!--    </div>-->
    <template v-if="isMeaningful(data)">

      <template v-if="(data.bizType || {}).code === 'SHOP_AUTH_EXPIRES'">
        <gj-area-title style="margin-bottom: 10px">授权已失效</gj-area-title>
        <div class="color333" style="padding: 0 14px; font-size: 12px;">
          <div class="mb5">{{convertToFullDate(new Date(data.createTime), 'yyyy/MM/dd')}}</div>
          <div class="mb5">
            <span v-html="data.title"></span>
          </div>
          <div style="margin-bottom: 20px">以免影响系统正常使用，请前往刷新授权！</div>
          <div style="width: 50%; min-width: 500px;">
            <div style="display: flex;flex-direction: column;align-items: center;">
              <img src="./img/auth.png" style="margin-bottom: 14px;width: 70%;display: block;"/>
              <div>
                <gj-button v-if="$permission('market:view')" class="button-styl"
                           @click="$router.push({path: '/system/market', query: {marketId: data.content}})">去授权</gj-button>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template v-else-if="(data.bizType || {}).code === 'ADS_STRATEGY_RESULT'">
        <gj-area-title style="margin-bottom: 10px">{{data.title}}</gj-area-title>
        <div class="color333" style="padding: 0 14px; font-size: 12px;">
          <div class="mb5">{{convertToFullDate(new Date(data.createTime), 'yyyy/MM/dd')}}</div>
          <div class="mb5">
            <span v-html="data.content"></span>
            <div>如需查看明细，请在广告-<gj-link @click="$router.push('/ad/strategy-adjust-log');">调整日志</gj-link>中查看</div>
          </div>
        </div>
      </template>

      <template v-else-if="(data.bizType || {}).code === 'ADS_AUTO_RULE_RESULT'">
        <gj-area-title style="margin-bottom: 10px">{{data.title}}</gj-area-title>
        <div class="color333" style="padding: 0 14px; font-size: 12px;">
          <div class="mb5">{{convertToFullDate(new Date(data.createTime), 'yyyy/MM/dd')}}</div>
          <div class="mb5">
            <span v-html="data.content"></span>
            <div>如需查看明细，请在商品广告-操作日志中查看</div>
          </div>
        </div>
      </template>

      <template v-else>
        <div>
          <gj-area-title style="margin-bottom: 10px">充值提醒</gj-area-title>
          <div class="color333" style="padding: 0 14px; font-size: 12px;">
            <div class="mb5">{{convertToFullDate(new Date(data.createTime), 'yyyy/MM/dd')}}</div>
            <div class="mb5">
              <span v-html="data.content"></span>
              <span>。您上次充值时间: {{accomplishDate}}</span>
            </div>
          </div>
          <div class="color333">
            <div style="width: 50%; min-width: 500px; margin: 0 auto">
              <div style="display: flex;flex-direction: column;align-items: center;">
                <img src="./img/up.png" style="margin-bottom: 14px;width: 50%;display: block;"/>
                <gj-button
                    v-if="$permission('package:add')"
                    @click="routePackage"
                    type="primary"
                    style="border-radius: 19px;margin-bottom: 8px;"
                    >
                  去充值
                </gj-button>
              </div>
            </div>
          </div>
        </div>
      </template>

    </template>
  </div>
</template>

<script>

  import {isMeaningfulMixin} from "../../../../minxins";
  import {convertToFullDate} from "../../../../utils/date.util";

  export default {
    name: "app-account-message-modal",
    mixins: [isMeaningfulMixin],
    props: {
      data: null,
      accomplishDate: null
    },
    data() {
      return {
        convertToFullDate: convertToFullDate
      }
    },
    methods:{
      routePackage(){
        this.$router.push({
          path: '/setting/erp-package'
        });
      }
    }
  }
</script>

<style scoped>
  .color333 {
    color: #333;
  }
  .bold {
    font-weight: bold;
  }
  .mb5 {
    margin-bottom: 5px;
  }
</style>
